// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GltRDWggDwK1w5 {
  position: relative;
}
.MgVd6mg8SqWux0 {
  margin-bottom: var(--ds-space-050, 4px);
  font-size: 20px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 24px;
}
.QnQ31VycOIzcHI {
  margin-bottom: var(--ds-space-250, 21px);
  font-size: 14px;
  line-height: 20px;
}
.xlJgA3oCjIYOYd {
  position: absolute;
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var PremiumTrialPaymenConfirmation = `GltRDWggDwK1w5`;
export var title = `MgVd6mg8SqWux0`;
export var description = `QnQ31VycOIzcHI`;
export var cancelButton = `xlJgA3oCjIYOYd`;
export default ___CSS_LOADER_EXPORT___;
